jQuery(function ($) {
	'use strict';

	var $list = $('.archive-list').children('li');
	var listLen = $list.length;
	var $moreBtn = $('#js-archive-more');
	var initDisplay = 15;
	var addDisplay = 15;
	var showNum = initDisplay;


	/**
	 * 続きがなければボタンを削除
	 *
	 * @param prm
	 */
	function buttonCheck(prm) {
		if (prm.listLen <= prm.showNum) {
			$moreBtn.hide();
		}
	}

	$list.slice(initDisplay).hide();
	buttonCheck({
		listLen: listLen,
		showNum: showNum
	});

	$moreBtn.on('load click', function () {
		showNum += addDisplay;
		$list.slice(initDisplay, showNum).show();
		buttonCheck({
			listLen: listLen,
			showNum: showNum
		});
		return false;
	});

});
